import { Stack, Typography } from "@mui/material";
import { LangConstant } from "const";
import React from "react";
import { useTranslation } from "react-i18next";

const NoData = ({ content, ...otherProps }) => {
  const { t: getLabel } = useTranslation(LangConstant.NS_COMMON);

  return (
    <Stack justifyContent="center" alignItems="center" flexGrow={1} {...otherProps}>
      <Typography style={{ fontSize: "16px", fontWeight: 400, color: "#CBCBCA" }}>
        {content || getLabel(LangConstant.TXT_NOT_FOUND)}
      </Typography>
    </Stack>
  );
};

export default NoData;
